import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin, Clock, Facebook, Instagram, Star } from 'lucide-react';
import { businessInfo } from '../data/mock';

export const Footer = () => {
  return (
    <footer className="bg-black text-white">
      <div class="container mx-auto px-6 py-12">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Brand */}
          <div className="space-y-4">
            <Link to="/">
              <img 
                src="https://customer-assets.emergentagent.com/job_shine-mobile-14/artifacts/48ukm1vz_image.png" 
                alt="Precision Mobile Detailing Logo" 
                className="h-16 w-auto"
              />
            </Link>
            <div className="flex items-center gap-2">
              <div className="flex">
                {[...Array(5)].map((_, i) => (
                  <Star key={i} className="w-4 h-4 fill-yellow-400 text-yellow-400" />
                ))}
              </div>
              <span className="text-sm">5-Star Rated</span>
            </div>
            <p className="text-gray-400 leading-relaxed">
              Professional mobile auto detailing serving Redlands and communities throughout the Inland Empire.
            </p>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Services</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/services" className="text-gray-400 hover:text-white transition-colors">
                  Mobile Auto Detailing
                </Link>
              </li>
              <li>
                <Link to="/services" className="text-gray-400 hover:text-white transition-colors">
                  Interior Detailing
                </Link>
              </li>
              <li>
                <Link to="/services" className="text-gray-400 hover:text-white transition-colors">
                  Paint Enhancement
                </Link>
              </li>
              <li>
                <Link to="/services/ceramic-coating" className="text-gray-400 hover:text-white transition-colors">
                  Ceramic Coating
                </Link>
              </li>
              <li>
                <Link to="/services/headlight-restoration" className="text-gray-400 hover:text-white transition-colors">
                  Headlight Restoration
                </Link>
              </li>
            </ul>
          </div>

          {/* Service Areas */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Service Areas</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/service-areas/redlands-ca" className="text-gray-400 hover:text-white transition-colors">
                  Redlands
                </Link>
              </li>
              <li>
                <Link to="/service-areas/loma-linda-ca" className="text-gray-400 hover:text-white transition-colors">
                  Loma Linda
                </Link>
              </li>
              <li>
                <Link to="/service-areas/yucaipa-ca" className="text-gray-400 hover:text-white transition-colors">
                  Yucaipa
                </Link>
              </li>
              <li>
                <Link to="/service-areas/riverside-ca" className="text-gray-400 hover:text-white transition-colors">
                  Riverside
                </Link>
              </li>
              <li>
                <Link to="/service-areas/san-bernardino-ca" className="text-gray-400 hover:text-white transition-colors">
                  San Bernardino
                </Link>
              </li>
              <li>
                <Link to="/service-areas/rancho-cucamonga-ca" className="text-gray-400 hover:text-white transition-colors">
                  Rancho Cucamonga
                </Link>
              </li>
            </ul>
          </div>

          {/* Quick Links - moved to end */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Company</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-gray-400 hover:text-white transition-colors">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/services" className="text-gray-400 hover:text-white transition-colors">
                  Services
                </Link>
              </li>
              <li>
                <Link to="/service-areas" className="text-gray-400 hover:text-white transition-colors">
                  Service Areas
                </Link>
              </li>
              <li>
                <Link to="/booking" className="text-gray-400 hover:text-white transition-colors">
                  Book Appointment
                </Link>
              </li>
              <li className="pt-2">
                <a href={`tel:${businessInfo.phone}`} className="text-gray-400 hover:text-white transition-colors">
                  {businessInfo.phone}
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-800 mt-12 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-gray-400 text-sm">
            © {new Date().getFullYear()} Precision Mobile Detailing. All rights reserved.
          </p>
          <div className="flex gap-4">
            <a href="#" className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center hover:bg-white/20 transition-colors">
              <Facebook className="w-5 h-5" />
            </a>
            <a href="#" className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center hover:bg-white/20 transition-colors">
              <Instagram className="w-5 h-5" />
            </a>
          </div>
        </div>

        {/* Legal Links */}
        <div className="border-t border-white/10 mt-8 pt-6">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4 text-sm text-gray-400">
            <p>&copy; {new Date().getFullYear()} Precision Mobile Detailing. All rights reserved.</p>
            <div className="flex gap-6">
              <Link to="/privacy-policy" className="hover:text-white transition-colors">
                Privacy Policy
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
